/**
 * Cookie-free visitor status helpers using localStorage.
 * A visitor is "new" when no first-seen timestamp exists yet.
 */

export const VISITOR_FIRST_SEEN_KEY = 'agent_visitor_first_seen_at'

/**
 * Memoize the first result per JS module load so React 18 Strict Mode (dev) does not run this
 * twice: first call would write first-seen, second would read it and incorrectly mark returning.
 * @type {boolean | undefined}
 */
let _newVisitorResultCache

/**
 * Ensure the first-seen timestamp exists, then report if visitor is new.
 * @returns {boolean} true when this is the first detected visit on this browser profile.
 */
export function initializeVisitorStatus() {
  if (_newVisitorResultCache !== undefined) {
    return _newVisitorResultCache
  }
  try {
    const firstSeenAt = localStorage.getItem(VISITOR_FIRST_SEEN_KEY)
    if (firstSeenAt) {
      _newVisitorResultCache = false
      return false
    }
    localStorage.setItem(VISITOR_FIRST_SEEN_KEY, new Date().toISOString())
    _newVisitorResultCache = true
    return true
  } catch {
    _newVisitorResultCache = false
    return false
  }
}

/**
 * Map visitor status to auth modal mode.
 * @param {boolean} isNewVisitor
 * @returns {'login'|'register'}
 */
export function getAuthModalModeForVisitor(isNewVisitor) {
  return isNewVisitor ? 'register' : 'login'
}
